import PropTypes from 'prop-types'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

export const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(2)}px`,
  },
  header: {
    fontSize: 28,
    fontWeight: 700,
    lineHeight: '32px',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      fontSize: 32,
      lineHeight: '36px',
      marginBottom: theme.spacing(4),
    },
  },
})

function FormHeading(props) {
  const {
    classes, heading, subHeading, className: classNameProp
  } = props

  const className = classNames(classes.root, classNameProp)

  return (
    <div className={className}>
      {heading ? (
        <Typography className={classes.header}>{heading}</Typography>
      ) : null}
      {subHeading ? (
        <Typography variant="body1" gutterBottom>
          {subHeading}
        </Typography>
      ) : null}
    </div>
  )
}

FormHeading.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
}

FormHeading.defaultProps = {}

export default withStyles(styles)(FormHeading)



// WEBPACK FOOTER //
// ./src/components/molecules/FormHeading.js